import React from 'react';
import {Box} from "@mui/material";
import {IconContext} from "react-icons";
import {IoColorPaletteOutline} from "react-icons/io5";
import {IArticle} from "../../../../../../utils/interfaces/tannery_production/articles/IArticle";


const getIconsForCustomField = (row: IArticle, theme: any, t: any) => {
    const icons = [];
    const icon_color = theme.palette.primary.main

    icons.push(
        row.colors.length > 0 &&
        <IoColorPaletteOutline color={icon_color} title='COLORS INSIDE'></IoColorPaletteOutline>
    );


    return icons;
};

export const customArticleCellRenderer = (rowData: IArticle, theme: any, t: any) => {
    const icons = getIconsForCustomField(rowData, theme, t);
    return (
        <IconContext.Provider
            value={{size: "1.3rem"}}
        >
            <Box display="flex" sx={{gap: 0.5}}>
                {icons.map((icon, index) => (
                    <span key={index}>{icon}</span>
                ))}
            </Box>
        </IconContext.Provider>

    );
};

export default customArticleCellRenderer;
